import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { getMyProfile, updateMyProfile, uploadMyPhoto } from '../utils/api';
import { ProfileEditor } from '../components/ProfileParts';
import ProfileView, { EditPanel } from '../components/ProfileView';

/* My Profile — the person's own profile, shown the way it looks to the company.
   "Edit profile" opens a side panel where they change their photo, bio and fun fact.
   Name, nickname, roles and status are set by an admin on Staff Profiles.            */

export default function MyProfile() {
  const [me, setMe] = useState(null);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { getMyProfile().then(setMe).catch(() => setMe({ linked: false })); }, []);

  async function save(f) {
    setSaving(true);
    try { const r = await updateMyProfile({ bio: f.bio, fun_fact: f.fun_fact }); setMe({ linked: true, ...r }); setEditing(false); toast.success('Profile saved'); }
    finally { setSaving(false); }
  }
  const photo = async data => { const r = await uploadMyPhoto(data); setMe({ linked: true, ...r }); };

  return (
    <div className="page-body" style={{ paddingTop: 22 }}>
      {!me ? <div className="loader"><div className="spinner" /></div>
        : !me.linked ? (
          <div style={{ maxWidth: 640, background: '#fff', border: '1px solid #D9E2DC', borderRadius: 18, padding: 28 }}>
            <h2 style={{ marginTop: 0, fontFamily: "'Fraunces',Georgia,serif" }}>Your profile isn't set up yet</h2>
            <p style={{ color: '#5E6E66', lineHeight: 1.6, marginBottom: 0 }}>Your login ({me.username || 'this account'}) isn't linked to anyone on the Staff list. Ask an admin to link it under Users, using the same name as on the Staff list.</p>
          </div>
        ) : (
          <>
            <ProfileView person={me} self onEdit={() => setEditing(true)} />
            {editing && (
              <EditPanel title="Edit your profile" onClose={() => setEditing(false)}>
                <ProfileEditor person={me} selfMode onSave={save} onPhoto={photo} onCancel={() => setEditing(false)} saving={saving} />
              </EditPanel>
            )}
          </>
        )}
    </div>
  );
}
